module.exports = __webpack_public_path__ + "img/infrastructure-7.0ea363db.png";